/**
 * StatsCard Component
 * Reusable statistics display card
 */

import React from 'react';
import styled from 'styled-components';

const StatsCardContainer = styled.div`
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  padding: var(--spacing-lg);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
`;

const StatsLabel = styled.div`
  font-size: var(--font-sm);
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
`;

const StatsValue = styled.div<{ color?: string }>`
  font-size: var(--font-xxl);
  font-weight: var(--font-bold);
  color: ${({ color }) => color || 'var(--text-primary)'};
`;

const StatsChange = styled.div<{ positive?: boolean }>`
  font-size: var(--font-sm);
  color: ${({ positive }) => (positive ? 'var(--accent-green)' : 'var(--accent-red)')};
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
`;

const StatsIcon = styled.div`
  font-size: 20px;
`;

interface StatsCardProps {
  label: string;
  value: string | number;
  icon?: string;
  change?: {
    value: string;
    positive: boolean;
  };
  color?: string;
  onClick?: () => void;
}

const StatsCard: React.FC<StatsCardProps> = ({ label, value, icon, change, color, onClick }) => {
  return (
    <StatsCardContainer onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
      <StatsLabel>
        {icon && <StatsIcon>{icon}</StatsIcon>}
        {label}
      </StatsLabel>
      <StatsValue color={color}>{value}</StatsValue>
      {change && (
        <StatsChange positive={change.positive}>
          {change.positive ? '↑' : '↓'} {change.value}
        </StatsChange>
      )}
    </StatsCardContainer>
  );
};

export default StatsCard;
